export default "__VITE_ASSET__BJypRw8c__"